import React from 'react';
import { reduxForm } from 'redux-form';

import { ColorPickerFieldComponent } from 'components/form/color-picker/color-picker-field.component';
import { AppTextField } from 'components/form/appTextField';
import { AppFileField } from 'components/form/appFileField';
import { AppTextAreaField } from 'components/form/appTextAreaField';

export const PreviewTemplate = reduxForm<any, any>({})(() => {
  return (
    <>
      <div>Styling</div>
      <ColorPickerFieldComponent name="header.color" label="Color" disabled placeholder="-" />
      <AppFileField name="header.logo" label="Logo" disabled placeholder="-" />
      <div>Content</div>
      <AppTextField name="content.senderEmail" label="From email address" disabled placeholder="-" />
      <AppTextField name="content.organisationName" label="Organisation name" disabled placeholder="-" />
      <AppTextAreaField name="content.text" label="Bottom text" disabled placeholder="-" />
    </>
  );
});
